import { render, staticRenderFns } from "./FuelSurchargeBulkUpload.vue?vue&type=template&id=b6219ab4"
import script from "./FuelSurchargeBulkUpload.vue?vue&type=script&lang=js"
export * from "./FuelSurchargeBulkUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports